const feedback = {
    error: "#c5202f",
    notice: "#a35513",
    success: "#00762e",
};

export default feedback;
